module.exports = __webpack_public_path__ + "static/media/Nucleo v6.a8452d12.glb";